import { render, staticRenderFns } from "./MobileWarning.vue?vue&type=template&id=01776dfa&scoped=true&"
import script from "./MobileWarning.vue?vue&type=script&lang=ts&"
export * from "./MobileWarning.vue?vue&type=script&lang=ts&"
import style0 from "./MobileWarning.vue?vue&type=style&index=0&id=01776dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01776dfa",
  null
  
)

export default component.exports